import { render, staticRenderFns } from "./withdrawalSettings.vue?vue&type=template&id=9cb3ac0c&scoped=true&"
import script from "./withdrawalSettings.vue?vue&type=script&lang=js&"
export * from "./withdrawalSettings.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalSettings.vue?vue&type=style&index=0&id=9cb3ac0c&prod&scoped=true&lang=less&"
import style1 from "./withdrawalSettings.vue?vue&type=style&index=1&id=9cb3ac0c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb3ac0c",
  null
  
)

export default component.exports